// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__39Lq1","insightsList":"newBusinessInsightsMenu_insightsList__4y31N","active":"newBusinessInsightsMenu_active__1VXmT"};